import React, { PropTypes, Component } from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import ChartComponent from "./ChartComponent";
import * as ChartPageActions from "actions/ChartPageActions";


class ChartSectionContent extends Component {
	constructor(props) {
		super(props);
		this.handleWindowResize = this.handleWindowResize.bind(this);
	}
	componentDidMount() {
		var { resized } = this.props.pageProps;
		if (resized) this.handleWindowResize();
	}
	componentDidUpdate() {
		var { resized } = this.props.pageProps;
		if (resized) this.handleWindowResize();
	}
	handleWindowResize() {
		var el = this.refs.page;
		var width = el.clientWidth;
		var height = el.clientHeight;
		// console.log(el);

		var { resizeChart } = this.props;
		resizeChart(width, height);
	}
	render() {
		return (
			<div className="section-body" ref="page">
				{this.props.pageProps.chartComponent.map((item, i) => 
					<ChartComponent key={i} ref={"chartComponent_" + i} {...item} resized={this.props.pageProps.resized} index={i} />
				)}

			</div>
		);
	}
}


ChartSectionContent.propTypes = {
	pageProps: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
	return { resizeChart: bindActionCreators(ChartPageActions.resizeChart, dispatch) };
}
export default connect(state => state, mapDispatchToProps)(ChartSectionContent);



/** WEBPACK FOOTER **
 ** ./src/scripts/components/page/ChartPage/ChartSectionContent.jsx
 **/